export default __webpack_public_path__ + "static/media/finishing-3.35305bed.webp";